/* eslint-disable max-len */
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import SvgIcon from '@material-ui/core/SvgIcon';
import { IconSize, DefaultIconSizeValue } from './constants';
import theme from 'theme';

export const IconSizeValue = {
  ...DefaultIconSizeValue,
  [IconSize.Large]: '43px',
};

const useStyles = makeStyles(() => ({
  root: {
    fill: 'none',
  },
}));

const ImageIcon = ({ size = IconSize.Medium, className }) => {
  const classes = useStyles();
  return (
    <SvgIcon
      style={ { width: IconSizeValue[size], height: IconSizeValue[size] } }
      className={ classNames(classes.root, className) }
      viewBox="0 0 47 46"
    >
      <rect width="47" height="46" rx="4" fill={ theme.palette.primary.main } />
      <path
        d="M19.8333 29H16.3333C15.7145 29 15.121 28.7542 14.6834 28.3166C14.2458 27.879 14 27.2855 14 26.6667V16.1667C14 15.5478 14.2458 14.9543 14.6834 14.5168C15.121 14.0792 15.7145 13.8333 16.3333 13.8333H32.6667C33.2855 13.8333 33.879 14.0792 34.3166 14.5168C34.7542 14.9543 35 15.5478 35 16.1667V26.6667C35 27.2855 34.7542 27.879 34.3166 28.3166C33.879 28.7542 33.2855 29 32.6667 29H29.1667M28 24.3333L24.5 20.8333M24.5 20.8333L21 24.3333M24.5 20.8333V32.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ImageIcon;
